/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WaitlistRow } from './WaitlistRow';
import {
    WaitlistRowFromJSON,
    WaitlistRowFromJSONTyped,
    WaitlistRowToJSON,
    WaitlistRowToJSONTyped,
} from './WaitlistRow';

/**
 * 
 * @export
 * @interface WidgetDataWaitlistWidgetData
 */
export interface WidgetDataWaitlistWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataWaitlistWidgetData
     */
    $type?: WidgetDataWaitlistWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<WaitlistRow>}
     * @memberof WidgetDataWaitlistWidgetData
     */
    items: Array<WaitlistRow>;
}


/**
 * @export
 */
export const WidgetDataWaitlistWidgetDataTypeEnum = {
    Waitlist: 'waitlist'
} as const;
export type WidgetDataWaitlistWidgetDataTypeEnum = typeof WidgetDataWaitlistWidgetDataTypeEnum[keyof typeof WidgetDataWaitlistWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataWaitlistWidgetData interface.
 */
export function instanceOfWidgetDataWaitlistWidgetData(value: object): value is WidgetDataWaitlistWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function WidgetDataWaitlistWidgetDataFromJSON(json: any): WidgetDataWaitlistWidgetData {
    return WidgetDataWaitlistWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataWaitlistWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataWaitlistWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(WaitlistRowFromJSON)),
    };
}

export function WidgetDataWaitlistWidgetDataToJSON(json: any): WidgetDataWaitlistWidgetData {
    return WidgetDataWaitlistWidgetDataToJSONTyped(json, false);
}

export function WidgetDataWaitlistWidgetDataToJSONTyped(value?: WidgetDataWaitlistWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(WaitlistRowToJSON)),
    };
}

